import React, { useState, useEffect } from "react";
import { Card, CardHeader, Icon, Title, List, StandardListItem } from "@ui5/webcomponents-react";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PendingIcon from '@mui/icons-material/Pending';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

const ExpenseStatusDistributionCardApproved = ({ expenseData }) => {
  const [loading, setLoading] = useState(true);
  const [totalExpenses, setTotalExpenses] = useState(0);
  const [approvedCount, setApprovedCount] = useState(0);
  const [initiatedCount, setInitiatedCount] = useState(0);
  const [notApprovedCount, setNotApprovedCount] = useState(0);

  useEffect(() => {
    const calculateApprovedCount = () => {
      if (!expenseData || expenseData.length === 0) {
        setTotalExpenses(0);
        setApprovedCount(0);
        setInitiatedCount(0);
        setNotApprovedCount(0);
        setLoading(false);
        return;
      }

      let approved = 0;
      let initiated = 0;
      let notApproved = 0;

      expenseData.forEach((expense) => {
        if (expense.status === "Approved") {
          approved++;
        } else if (expense.status === "Initiated") {
            initiated++;
          } else {
            notApproved++;
          }
      });

      setTotalExpenses(expenseData.length);
      setApprovedCount(approved);
      setInitiatedCount(initiated);
      setNotApprovedCount(notApproved);
      setLoading(false);
    };

    calculateApprovedCount();
  }, [expenseData]);

  return (
    <>
      {/* Expense Status Distribution Card */}
     

      <Card
        square
        header={<CardHeader avatar={<Icon name="validate" />} subtitleText={`Out of ${totalExpenses}`} titleText="Expense Status Approved" />}
      >
        <Box display="flex" justifyContent="right"  sx={{ mr: 2, mb: 2 }}>
          <Typography variant="h5"  style={{ fontWeight: 'bold', color: 'grey', fontSize: 45, fontFamily: 'SapFiori72' }}> {approvedCount}</Typography>
        </Box>
      </Card>

      <Card
        square
        header={<CardHeader avatar={<Icon name="in-progress" />} subtitleText={`Out of ${totalExpenses}`} titleText="Expense Status Initiated" />}
      >
        <Box display="flex" justifyContent="right"  sx={{ mr: 2, mb: 2 }}>
          <Typography variant="h5"  style={{ fontWeight: 'bold', color: 'grey', fontSize: 45, fontFamily: 'SapFiori72' }}>{initiatedCount}</Typography>
        </Box>
      </Card>
	  
      <Card
        square
        header={<CardHeader avatar={<Icon name="pending" />} subtitleText={`Out of ${totalExpenses}`} titleText="Expense Status Pending" />}
      >
        <Box display="flex" justifyContent="right"  sx={{ mr: 2, mb: 2 }}>
          <Typography variant="h5"  style={{ fontWeight: 'bold', color: 'grey', fontSize: 45, fontFamily: 'SapFiori72' }}>{notApprovedCount}</Typography>
        </Box>
      </Card>

    </>
  );
};

export default ExpenseStatusDistributionCardApproved;
